/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Name_SplitInputs */



/**
* | output |
* | --- |
* | "First + last" |
*
* @param {Team_Manager_Import_Name_SplitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_name_split = /** @type {((inputs?: Team_Manager_Import_Name_SplitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Name_SplitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prénom + nom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vor- + Nachname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome + cognome")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя + фамилия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre + apellido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("名 + 姓")
	if (locale === "ja") return /** @type {LocalizedString} */ ("名 + 姓")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहला + अंतिम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome + apelido")
	return /** @type {LocalizedString} */ ("First + last")
});